var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row"},_vm._l((_vm.staffList),function(staff){return _c('div',{key:staff.id,staticClass:"col-md-4"},[_c('b-checkbox',{attrs:{"name":"check-button","inline":"","checked":_vm.isStaffExist(staff)},on:{"change":function($event){return _vm.staffChanged(staff)}}},[_vm._v(" "+_vm._s(staff.name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }